<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAnalyticsProgress_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M20.172 11.464a.98.98 0 1 0 1.697-.98L19.562 6.49a.98.98 0 0 0-1.42-.306.98.98 0 0 0-.407.526l-2.37 7.295-2.581-5.342a.98.98 0 0 0-1.029-.543.98.98 0 0 0-.782.581l-2.45 5.617-1.641-2.842a.98.98 0 0 0-.819-.49.98.98 0 0 0-.872.419l-3.015 4.333a.98.98 0 0 0 1.607 1.12L5.94 13.76l1.792 3.105a.98.98 0 0 0 1.634.095 1 1 0 0 0 .315-.395l2.252-5.163 2.666 5.517a.98.98 0 0 0 .816.551.98.98 0 0 0 1.101-.662l2.427-7.475z"
        clip-rule="evenodd"
    />
</svg>
